import { render, staticRenderFns } from "./productFiling.vue?vue&type=template&id=c91cf982&scoped=true&"
import script from "./productFiling.vue?vue&type=script&lang=js&"
export * from "./productFiling.vue?vue&type=script&lang=js&"
import style0 from "./productFiling.vue?vue&type=style&index=0&id=c91cf982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91cf982",
  null
  
)

export default component.exports